export function LandingPage() {
  return (
    <main className="flex h-full flex-col items-center justify-center px-6 text-center">
      <p className="text-[28px] font-semibold leading-tight tracking-tight text-text-1">
        Open an episode by URL.
      </p>
      <p className="mt-3 max-w-md text-[14px] text-text-3">
        Paste the URL your admin sent you in the address bar above. Bookmarks are your
        recents list — there is no episode picker here.
      </p>
    </main>
  );
}
